import React from 'react';
import { string, object, number } from 'prop-types';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

import useStyles from 'hooks/useStyles';
import getDateTimeWithStatus from 'routes/live/utils/getDateTimeWithStatus';

import WatchForFreeLink from '../WatchForFreeLink';
import styles from './ScheduleItem.scss';

function ScheduleItem({ name, time, topicId, topicName }) {
  useStyles(styles);
  const { t } = useTranslation(['live']);
  const dateTimeString = getDateTimeWithStatus(time, t);
  const { isLive } = time;

  return (
    <div className={styles.root}>
      <div>
        <div className={styles.title}>
          {isLive && `(${t('live:home.content.today.video.desc')})`}
          {name}
        </div>
        <div className={cx(styles.time, { [styles.isLive]: isLive })}>
          {dateTimeString}
        </div>
      </div>

      <WatchForFreeLink isShow={!isLive} id={topicId} name={topicName} />
    </div>
  );
}

ScheduleItem.propTypes = {
  name: string.isRequired,
  time: object.isRequired,
  topicId: number.isRequired,
  topicName: string.isRequired,
};

export default ScheduleItem;
